export const blogData = [
    {
        displayName: "Memoization in Javascript and React",
        url: "https://parthgabani.hashnode.dev/memoization-in-javascript-and-react",
        description:
            "According to Wikipedia definition of memoization is : In computing, memoization is an optimization technique used primarily to speed up computer programs by storing the results of expensive function calls and returning the cached result when the same inputs occur again....",
    },
    {
        displayName: "Temporal dead zone and Hoisting in Javascript",
        url: "https://parthgabani.hashnode.dev/temporal-dead-zone-and-hoisting-in-javascript",
        description:
            "If you are learning Javascript, you might come across temporal dead zone and hoisting. This topic is important to learn as it will decide whether you can access variables before the declaration....",
    },
    {
        displayName: "Event Delegation in Javascript",
        url: "https://parthgabani.hashnode.dev/event-delegation-in-javascript",
        description:
            "Events are an integral part of javascript which makes it dynamic. Event delegation is a very important concept as by using it we can reduce event handlers and improve the performance of our application. For a better understanding of event delegation, we need to know about event bubbling....",
    },
];
